'use client';
import { jsx } from 'react/jsx-runtime';
import classnames from '../../node_modules/classnames/index.js';
import { getSvgContent } from './Icon.utils.js';
import modules_c4937a59 from './Icon.module.scss.js';

const Icon = ({ ariaLabel, ariaLabelledBy, ariaDescribedBy, className, content, appearance, // Cannot give a default value here, as we would be unable to determine if it was set or not (which determines if the deprecatedColor is used)
"data-testid": testId, id, width: w = 16, height: h = 16, deprecatedColor, ...rest }) => {
    const { attributes: { 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    class: iconClass, width: nativeWidth, height: nativeHeight, ...attributes }, innerHTML, } = getSvgContent(content);
    // Appearance takes priority over deprecatedColor. Neither appearance nor deprecatedColor is provided, we fallback to the "default" appearance.
    let appearanceStyle = "";
    if (appearance || !deprecatedColor) {
        appearanceStyle = modules_c4937a59[appearance || "default"];
    }
    const width = typeof w === "string" ? w : `${w}px`;
    const height = typeof h === "string" ? h : `${h}px`;
    return (jsx("svg", { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, ...(!ariaLabel && !ariaLabelledBy && !ariaDescribedBy
            ? { "aria-hidden": true }
            : {}), viewBox: `0 0 ${nativeWidth || 16} ${nativeHeight || 16}`, fill: "inherit", className: classnames(modules_c4937a59.icon, appearanceStyle, className), style: appearanceStyle ? {} : { fill: deprecatedColor }, ...attributes, width: width, height: height, "data-testid": testId, 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: innerHTML }, id: id, role: "img", ...rest }));
};

export { Icon };
//# sourceMappingURL=Icon.js.map
